export default __webpack_public_path__ + "static/media/jaipur2.31a655ef.jpg";